import styled from 'styled-components';
import { flex } from '../../../../styles/utilities/flex';
import { textColor, THEME_BLACK, THEME_WARNING, themeColor } from '../../../../styles/basics/colors';
import { Link } from 'react-router-dom';
import { LCFormField } from '../../shared/LCFormField';
import LCFormFieldInputDropdown from '../../shared/LCFormFieldInputDropdown';

export const StTitleStatusWrapper = styled.div.attrs({ 'data-displayname': 'TitleStatusWrapper' })`
    display: grid;
    grid-template-columns: 1fr 1.2fr 1fr;
    grid-column-gap: 2em;
`;

export const StDetailViewWrapper = styled.div<{ assetWrapperHidden: boolean }>`
    display: grid;
    grid-template-columns: 2fr ${props => (props.assetWrapperHidden ? '0' : '1')}fr;
    grid-column-gap: 3em;
    margin-bottom: 120px;
    margin-top: 60px;
`;

export const StTitleButtonWrapper = styled.div`
    margin-bottom: 2.5em;
    height: 30px;
`;

export const StMetadataTitleWrapper = styled.div`
    width: 250px;
`;

export const StMetadataTitleWrapperEditState = styled.div`
    width: 250px;
    ${flex('row')};
    align-items: center;

    > a ~ a {
        margin-left: 10px;
    }

    button {
        width: 70px;
    }
`;

export const StTitle = styled.h3`
    ${textColor(THEME_BLACK)};
    font-weight: normal;
    font-size: 18px;
    margin: 0;
    flex-grow: 1;
`;

export const StLCProductDetailAssetsWrapper = styled.div`
    width: 320px;
    min-height: 100px;
`;

export const StRightAlignedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const StViewInLibxLink = styled(Link)<{ disabled?: boolean }>`
    font-size: 15px;
    margin-bottom: 15px;

    span {
        color: ${themeColor(THEME_BLACK)};
    }
    pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
    cursor: ${props => (props.disabled ? 'default' : 'initial')};
    opacity: ${props => (props.disabled ? '0.5' : 'initial')};
`;

export const StInfoSharedCollectionTitle = styled.div`
    font-size: 15px;
    text-align: right;
    font-weight: bold;
`;

export const StLCProductDetailMetaData = styled.div.attrs({ 'data-displayname': 'LCProductDetailMetaData' })`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 12.5em;
`;

export const StPairRow = styled.div`
    ${flex('row')};
    justify-content: flex-start;
    flex-grow: 1;
`;

export const StRightCol = styled.div`
    grid-row-start: 1;
    grid-row-end: 2;
`;

export const StLeftCol = styled.div`
    grid-row-start: 1;
    grid-row-end: 3;
`;

export const StSpacerVertical = styled.span`
    display: block;
    padding-left: 2.5em;
    padding-right: 2.5em;
`;

export const StSpacerHorizontal = styled.div`
    display: block;
    padding-bottom: 2.5em;
`;

export const elementWrapperSmallWidth = '150px';
export const elementWrapperMediumWidth = '300px';
export const StElementWrapper = styled.div<{ width: string }>`
    width: ${props => props.width};
`;

export const StAddFormField = styled(LCFormField)`
    min-height: unset;
`;

export const StAddButtonWrapper = styled.div`
    display: block;
    margin-top: 0.7em;
`;

export const StDisableInputDropdown = styled(LCFormFieldInputDropdown<string>)<{ disabled?: boolean }>`
    cursor: ${props => (props.disabled ? 'default' : 'initial')};
    pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
`;

export const StEnableDisableWrapper = styled.div<{ disabled: boolean }>`
    opacity: ${props => (props.disabled ? 0.5 : 'initial')};
`;

export const StStandardGenreWarning = styled.p`
    margin-top: 5px;
    font-size: 13px;
    line-height: 13px;
    color: ${themeColor(THEME_WARNING)};
`;
